require('../../asset/style/style.scss');
require('./application.scss');

const React = require('react');
const connect = require('react-redux').connect;
const actions = require('../../action/user-login/user-login');
const InternationalPhoneVerificationCode = require('../../component/mui/form/international-phone-verification-code');
const Toast = require('../../component/mui/toast.jsx');
const Loading = require('../../component/mui/loading.jsx');

const MessageDialog = require('../../component/mui/dialog/message-dialog.jsx');
const KryProtocol = require('../../component/user-login/kry-protocol.jsx');
import wechatIcon from '../../asset/images/BDWX.svg';
import alipayIcon from '../../asset/images/icon-alipay.svg';
import { getWeixinVersionInfo, isAlipayBrowser, getUrlParam, preventScrollIntoScroll } from '../../helper/common-helper';
import toastIcon from '../../asset/images/toast.svg';
import HttpsProtocolImage from '../../component/common/https-protocol-image';
import pageHelper from '../../helper/page-helper';
import { aliPageHelper } from '../../helper/ali-miniprogram-helper';
import FormattedMessage from '@/intl/formatted-message';
import { formatMessage } from '../../intl/helper';
import containnerText6 from '../../intl/messages/container/part6';
import containnerText5 from '../../intl/messages/container/part5';

const fromAppBtn = getUrlParam('fromApp');

const UserLoginApplication = React.createClass({
  displayName: 'UserLoginApplication',
  propTypes: {
    errorMessage: React.PropTypes.string,
    phoneNum: React.PropTypes.string,
    loadingInfo: React.PropTypes.object,
    supportInfo: React.PropTypes.object,
    setErrorMsg: React.PropTypes.func,
    fetchVerificationCode: React.PropTypes.func.isRequired,
    fetchLoginPhone: React.PropTypes.func.isRequired,
    fetchSupportInfo: React.PropTypes.func.isRequired,
    login: React.PropTypes.func,
    loginInfo: React.PropTypes.object,
  },

  getInitialState() {
    return {
      isDialogShow: false,
      logoUrl: '',
      isFromApp: false,
      showProtocolModal: false,
      checkbox: false,
    };
  },

  componentWillMount() {
    this.none = pageHelper.redirectWhenInit() || aliPageHelper.redirectWhenInit();
  },

  componentDidMount() {
    const { fetchLoginPhone, fetchSupportInfo } = this.props;
    fetchLoginPhone();
    fetchSupportInfo();
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps.supportInfo && this.props.supportInfo !== nextProps.supportInfo) {
      this.setState({ logoUrl: nextProps.supportInfo.brandIcon ? nextProps.supportInfo.brandIcon : toastIcon });
    }
  },

  onGetVerificationCode(phoneNum, nationTelCode) {
    this.props.fetchVerificationCode(phoneNum, nationTelCode);
  },

  onLogin() {
    console.log(this.state);
    if (!this.state.checkbox) {
      return;
    }
    const info = this.refs.verificationCode.refs.verificationCode.getInputInfo();
    const { setErrorMsg, login } = this.props;

    if (!info.validation.valid) {
      setErrorMsg(info.validation.msg);
      return;
    }

    this.refs.verificationCode.refs.verificationCode.refs.phoneVerificationCode.blur();
    this.refs.verificationCode.refs.verificationCode.refs.phoneVerificationCode.blur();
    login(info.data, this.handleLoginSuccess);
  },

  createThirdPartyLoginButton(thirdPartyInfo, loginParam) {
    if (fromAppBtn) {
      return;
    }

    return (
      <div className="oauth">
        <h3 className="o-text-divider oauth__title">
          <span className="">
            <FormattedMessage {...containnerText6.UserLoginApplicationLoginWithThirdPart} />
          </span>
        </h3>
        <button
          className={`o-btn o-btn--block o-btn--oval o-btn--${thirdPartyInfo.btnClassName}-outline o-btn--h44 oauth__btn`}
          onTouchTap={() => this.loginWithThirdParty(loginParam)}
        >
          <HttpsProtocolImage role="presentation" src={thirdPartyInfo.icon} style={{ width: 27, marginRight: 8 }} />
          <span>
            {thirdPartyInfo.text} <FormattedMessage {...containnerText6.UserLoginApplicationLogin} />
          </span>
        </button>
        <p className="oauth__tips">
          {formatMessage(containnerText6.userLoginPNLoginPrompt, { text: thirdPartyInfo.text })}
          <br />
          {formatMessage(containnerText6.userLoginBindPNAfterLogin)}
        </p>
      </div>
    );
  },

  createWechatLoginButton() {
    const wechatLoginInfo = {
      text: formatMessage(containnerText5.PayDetailApplicationWX),
      btnClassName: 'wechat',
      icon: wechatIcon,
    };

    return this.createThirdPartyLoginButton(wechatLoginInfo, { isWeixin: true });
  },

  createAlipayLoginButton() {
    const alipayLoginInfo = {
      text: formatMessage(containnerText5.PayDetailApplicationAlipay),
      btnClassName: 'alipay',
      icon: alipayIcon,
    };

    return this.createThirdPartyLoginButton(alipayLoginInfo, { isAlipay: true });
  },

  loginWithThirdParty(loginParam) {
    this.props.login(loginParam);
  },

  clearErrorMessage() {
    this.props.setErrorMsg('');
  },

  handleLoginSuccess(data) {
    const { isDialogShow } = this.state;
    if (data && data.cleartextPassword && data.firstLoginFlag && !isDialogShow) {
      this.setState({ isDialogShow: true });
    } else {
      // location.href = decodeURIComponent(data.returnUrl);
      location.href = data.returnUrl;
    }
  },

  handleLoginConfirm() {
    const { loginInfo } = this.props;
    location.href = decodeURIComponent(loginInfo.url);
  },

  showProtocolModal(type) {
    this.setState({ showProtocolModal: type }, () => {
      this.preventScrollIntoScroll = preventScrollIntoScroll('.login-protocal-modal', ['.login-protocal-modal-content']);
      this.preventScrollIntoScroll.addMethod();
    });
  },

  hideProtocolModal() {
    this.preventScrollIntoScroll.cancelMethod();
    this.setState({ showProtocolModal: false });
  },

  renderElement() {
    const { supportInfo, phoneNum } = this.props;
    const weixinInfo = getWeixinVersionInfo();
    const isAlipay = isAlipayBrowser() && supportInfo.alipay;
    const isWechat = weixinInfo.weixin && supportInfo.weixin;
    const wechatBtn = this.createWechatLoginButton();
    const alipayBtn = this.createAlipayLoginButton();

    const checkboxChange = event => {
      this.setState({
        checkbox: event.target.checked,
      });
    };
    return (
      <div>
        <InternationalPhoneVerificationCode
          className="phone-verification-code--login"
          hasForeignZone={supportInfo.xiangEQ}
          onGetVerificationCode={this.onGetVerificationCode}
          ref="verificationCode"
          phoneNum={phoneNum || ''}
        />
        <button
          disabled={!this.state.checkbox}
          className="o-btn o-btn--block o-btn--oval o-btn--h49 o-btn--linear p-login-btn"
          ref="loginBtn"
          onTouchTap={this.onLogin}
        >
          {fromAppBtn ? formatMessage(containnerText6.userLoginBindPNToOrder) : formatMessage(containnerText6.UserLoginApplicationLogin)}
        </button>
        {isWechat && wechatBtn}
        {isAlipay && alipayBtn}
        <p className="login-desc">
          <input id="input" className="checkbox" type="checkbox" checked={this.state.checkbox} onChange={checkboxChange} />
          <label id="label" htmlFor="input">
            <FormattedMessage {...containnerText6.UserLoginApplicationView} />
          </label>
          <span className="protocol-name" onTouchTap={() => this.showProtocolModal('service')}>
            <FormattedMessage {...containnerText6.UserLoginApplicationServiceAgreement} />
          </span>
          <FormattedMessage {...containnerText6.UserLoginApplicationAnd} />
          <span className="protocol-name" onTouchTap={() => this.showProtocolModal('privacy')}>
            <FormattedMessage {...containnerText6.UserLoginApplicationPrivacyPolicy} />
          </span>
          <FormattedMessage {...containnerText6.UserLoginApplicationAutoRegister} />
        </p>
      </div>
    );
  },

  render() {
    if (this.none) {
      return null;
    }
    const { errorMessage, loadingInfo, supportInfo, loginInfo } = this.props;
    const { isDialogShow, logoUrl, showProtocolModal } = this.state;
    const weixinInfo = getWeixinVersionInfo();
    const isAlipay = isAlipayBrowser() && supportInfo.alipay;
    const isWechat = weixinInfo.weixin && supportInfo.weixin;
    const loginHeaderImgStyle = {
      height: 100,
    };

    if (toastIcon !== logoUrl) {
      Object.assign(loginHeaderImgStyle, { width: 100, borderRadius: '50%' });
    }

    return (
      <div className="o-credit p-login-container o-bg-grey-linear" style={(isWechat || isAlipay) && !fromAppBtn ? { paddingTop: '7.5vh' } : {}}>
        <header className="p-login-header">
          <HttpsProtocolImage className="p-login-header__img" style={loginHeaderImgStyle} src={logoUrl} alt="" />
          <h1 className="p-login-header__title">
            <FormattedMessage {...containnerText6.UserLoginApplicationWelcome} />
            {supportInfo.brandName}
          </h1>
        </header>
        {this.renderElement()}
        {errorMessage ? <Toast errorMessage={errorMessage} clearErrorMsg={this.clearErrorMessage} /> : false}
        {loadingInfo.ing ? <Loading word={loadingInfo.text} /> : false}
        {isDialogShow && (
          <MessageDialog onConfirm={this.handleLoginConfirm} btnText={formatMessage(containnerText6.UserLoginApplicationiKnown)}>
            <div className="login-pwd-holder">
              <p className="login-pwd-item" style={{ fontSize: '20px', margin: '10px 0' }}>
                <FormattedMessage {...containnerText6.UserLoginApplicationbecameVip} />
              </p>
              <p className="login-pwd-item">{formatMessage(containnerText6.userLoginDefaultPW)}</p>
              <p className="login-pwd-item">
                {formatMessage(containnerText6.userLoginSixDigRePN)}
                {/* cleartextPassword为明文初始密码 后端返回*后就不显示了 */}
                {/* {loginInfo.loginData && loginInfo.loginData.cleartextPassword} */}
              </p>
            </div>
          </MessageDialog>
        )}
        {showProtocolModal && (
          <div className="login-protocal-modal">
            <div className="login-protocal-modal-content">{showProtocolModal && <KryProtocol type={showProtocolModal} />}</div>
            <div className="protocol-gradient"></div>
            <div className="protocol-button">
              <button className="o-btn o-btn--block o-btn--oval o-btn--h44 o-btn--primary" onTouchTap={this.hideProtocolModal}>
                <span>
                  <FormattedMessage {...containnerText6.UserLoginApplicationiKnown} />
                </span>
              </button>
            </div>
          </div>
        )}
      </div>
    );
  },
});
module.exports = connect(
  state => state,
  actions,
)(UserLoginApplication);



// WEBPACK FOOTER //
// ./src/container/user-login/application.jsx